// extracted by mini-css-extract-plugin
export default {"libraryAlert":"nTp87WM8EER2QrfrmO9t"};